import React, { useEffect } from 'react'
import { Box, Button, Container, Paper, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import AdminLoginForm from '../components/forms/AdminLoginForm/AdminLoginForm'
import { useAdminAuth } from '../context/AdminAuthContext'
import { LoadingSpinner } from '../components/layout/LoadingSpinner'

const AdminSignIn = () => {
  const navigate = useNavigate()
  const { isAuthenticated, authLoading } = useAdminAuth()

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin-panel')
    }
  }, [isAuthenticated, navigate])

  if (authLoading) {
    return (
      <div className="login-loading-container parentdiv">
        <LoadingSpinner />
        {/* <p>Checking authentication status...</p> */}
      </div>
    )
  }

  return (
    <>
      <Container maxWidth="lg" className="parentdiv register-form mb-40">
        <Box
          className="title_container mb-20"
          sx={{ display: 'flex', justifyContent: 'center' }}
        >
          <h1>Administrator Access</h1>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '30vh',
            padding: 0,
          }}
        >
          <Paper
            elevation={3}
            sx={{
              padding: 4,
              width: '100%',
              maxWidth: 600,
              backgroundColor: 'white',
            }}
          >
            <Typography variant="h4" align="center" gutterBottom sx={{ mb: 3 }}>
              <div className="title_container mb-20">
                <h2>Sign in to continue</h2>
              </div>
            </Typography>

            <AdminLoginForm />
          </Paper>
        </Box>
      </Container>
    </>
  )
}

export default AdminSignIn
